<template>
  <v-app>
    <div style="width: 100%; zoom: 0.90; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: 10%;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="padding-left: 15px; padding-top: 10px; vertical-align: top;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getCompanySetting('CompanySettings', 'CompanyAddress')}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="min-width: 35%; max-width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Statement Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.statement_date).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ data_location }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Channel</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ data_channel }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 10px; padding-bottom: 10px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ initvalue.statement_title }}</b></h4></div></td>
        </tr>
        <tr>
          <td><div style="text-align: center; font-size: medium;"><b>{{ initvalue.statement_subtitle }}</b></div></td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%;">
        <tr>
          <td style="width:45%; padding-left: 15px;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">Sales Rep</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.username }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.customeraddress }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.customerphone }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.customermobile }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            &nbsp;
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Num</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Customer</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">SO Date</th>
            <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="15%">Due Date</th>
            <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid; padding-right: 10px;" width="15%">SO Amount</th>
            <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid; padding-right: 10px;" width="15%">Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order) in initvalue.salesorders"  v-bind:key="order._id">
            <td style="vertical-align: top; padding-bottom: 5px;"><b>SO {{ order.salesordernum }}</b></td>
            <td style="vertical-align: top; padding-bottom: 5px;"><span style="font-size: 10pt;">{{ order.salesordername }}</span></td>
            <td style="vertical-align: top; padding-bottom: 5px;">{{ new Date(order.salesorderdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
            <td style="vertical-align: top; padding-bottom: 5px;">{{ order.salesorderduedate!=null ? new Date(order.salesorderduedate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}</td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right; padding-right: 10px;">{{ order.salesordertotal.toFixed(2) }} <span style="font-size: 8pt;">{{ order.primaryCurrency }}</span></td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right; padding-right: 10px;"><b>{{ order.balance.toFixed(2) }} <span style="font-size: 8pt;">{{ order.primaryCurrency }}</span></b></td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr v-if="initvalue.salesorders!=null">
            <td colspan="5" style="vertical-align: top; padding-bottom: 5px;">&nbsp;</td>
            <td style="vertical-align: top; padding-bottom: 5px; text-align: right; padding-right: 10px;"><b>{{ sum_total }} <span style="font-size: 8pt;">{{ initvalue.salesorders.length>0 ? initvalue.salesorders[0].primaryCurrency : '' }}</span></b></td>
          </tr>
          <tr><td colspan="6">&nbsp;</td></tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../util/tools';

export default {
  name: 'PrintInvoice',
  props: {
    id: String
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      data_company: {},
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getSalesRepOpenOrderRequest', 'getCompanyDataRequest']),
    getCompanySetting(code, name){
      if(this.data_company.settings==null || this.data_company.settings.length==0) return '';
      let results = this.data_company.settings.find(setting=>setting.settingcode==code);
      let result = results.settinglists.find(result=>result.settingname==name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    data_account(id){
      if(this.data_company.accounts==null || this.data_company.accounts.length==0) return null;
      let account = this.data_company.accounts.find(i=>i._id == id);
      if(account!=null) return account['accountcode'];
      return '';
    },
    convertCurrency(amount){
      let rate = parseFloat(this.initvalue.currencyRate);
      if(rate==null) rate = 0;
      return amount * rate;
    },
    data_balance_2(invoice){
      let rate = parseFloat(invoice.currencyRate);
      if(rate==null) rate = 1;
      let result = invoice.balance * rate;
      return result.toFixed(2)
    },

  },
  computed: {
    data_location(){
      if(this.data_company.locations==null || this.data_company.locations.length==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationcode'];
      return '';
    },
    data_channel(){
      if(this.data_company.channels==null || this.data_company.channels.length==0) return null;
      let channel = this.data_company.channels.find(i=>i._id == this.initvalue.channelid);
      if(channel!=null) return channel['channelcode'];
      return '';
    },
    data_region(){
      if(this.data_company.regions==null || this.data_company.regions.length==0) return null;
      let region = this.data_company.regions.find(i=>i._id == this.initvalue.regionid);
      if(region!=null) return region['regionname'];
      return '';
    },
    data_paymethod(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod;
      return null;
    },
    sum_total(){
      if(this.initvalue==null || this.initvalue.salesorders==null) return 0;
      let result = this.initvalue.salesorders;
      result = result.reduce((a, b) => a + (b.balance), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return result;
    },
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getSalesRepOpenOrderRequest(this.id);
      console.log(this.initvalue)
      //if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
      console.log(this.data_company)
    }
  },
}

</script>

<style src="./Print.scss" lang="scss"/>
